import homeMenu from './honda-main/homeMenu' /*** 模块化路由 **/
import other from './other/other'

export default [
    homeMenu,
    other
]